import { connect } from 'react-redux';
import { compose } from 'redux';

function CancelSurveyPage() {
    return (
        <div className="card Card-container" style={{ background: 'white' }}>
            <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12 no-Pd">
                    <div className="">
                        <div className="card-body" style={{ padding: '20px 0px' }}></div>
                    </div>
                </div>
            </div>

            <div className="login-container-width background">
                <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12 alignCen slogenText" style={{ margin: '20px 0px 5px' }}>
                        <div className="card-text Fw F1 alignCen thnkTxt">Thank You..</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = () => ({});

export default compose(connect(mapStateToProps))(CancelSurveyPage);
